module.exports = __webpack_public_path__ + "static/media/Rerun.f06b82a8.svg";